import React, {Component} from "react";
import {Button} from "./FormUI";
import AppointmentService from "../api/services/AppointmentService";
import RootModal from "./RootModal";
import {SanitizeClassNames} from "../common";

export default class ModalFactory {

}

export class YesNoModal extends Component {
	render() {
		const yesCaption = this.props.yesCaption || 'Yes';
		const noCaption = this.props.noCaption || 'No';
		return (<div className={SanitizeClassNames(this, "button-modal")} >
			<div className="modal-caption">{this.props.children}</div>
			<div className="table hmax layout-fixed button-bar">
				<div>
					<div>
						<Button className="red" caption={yesCaption} onClick={() => {
							if(this.props.onChoice)this.props.onChoice(true);
							RootModal.CloseModal();
						}}/>
					</div>
					<div>
						<Button caption={noCaption} onClick={() => {
							if(this.props.onChoice)this.props.onChoice(false);
							RootModal.CloseModal()
						}}/>
					</div>
				</div>
			</div>
		</div>)
	}
}





// WEBPACK FOOTER //
// ./src/components/ModalFactory.jsx